<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Abbreviations">
<p class="fmtitle"><a id="page_xviii">Abbreviations</a></p><a id="page_xviii">
<table>
<tbody><tr>
<td style="width:20%"><p class="abb">ABC</p></td>
<td style="width:80%"><p class="abb">American-British Conversations</p></td>
</tr>
<tr>
<td><p class="abb">ADB</p></td>
<td><p class="abb">American-Dutch-British</p></td>
</tr>
<tr>
<td><p class="abb">AEF</p></td>
<td><p class="abb">American Expeditionary Force</p></td>
</tr>
<tr>
<td><p class="abb">BEF</p></td>
<td><p class="abb">British Expeditionary Force</p></td>
</tr>
<tr>
<td><p class="abb">BJSM</p></td>
<td><p class="abb">British Joint Staff Mission, Washington, D.C.</p></td>
</tr>
<tr>
<td><p class="abb">CINC</p></td>
<td><p class="abb">commander in chief</p></td>
</tr>
<tr>
<td><p class="abb">CNO</p></td>
<td><p class="abb">chief of naval operations</p></td>
</tr>
<tr>
<td><p class="abb">RAF</p></td>
<td><p class="abb">Royal Air Force</p></td>
</tr>
<tr>
<td><p class="abb">SPENAVO</p></td>
<td><p class="abb">special naval observer</p></td>
</tr>
<tr>
<td><p class="abb">SPOBS</p></td>
<td><p class="abb">Special Army Observer Group in London</p></td>
</tr>
<tr>
<td><p class="abb">SWC</p></td>
<td><p class="abb">Supreme War Council</p></td>
</tr>
<tr>
<td><p class="abb">USSOG</p></td>
<td><p class="abb">U.S. Special Observer Group</p></td>
</tr>
<tr>
<td><p class="abb">WPD</p></td>
<td><p class="abb">War Plans Division</p></td>
</tr>
</tbody></table>
</a></section><a id="page_xviii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 12_Abbreviations.vue?548b91e2